export default __webpack_public_path__ + "static/media/logout.1a65bbde.svg";